import store from '../store';

const API_URL = process.env.API_PHP_SERVICE_URL || 'api_php/';

const getToken = () => {
  const { auth } = store.getState();

  return auth ? `Bearer ${auth.token}` : '';
};

const TIMEOUT = 10000;

class HttpError extends Error {
  constructor(status, message, data = {}) {
    super(message);
    this.status = status;
    this.data = data;
    Object.assign(this, data);

    console.error('Data provided to the above error:', this.data); // eslint-disable-line no-console
  }
}

const postData = method => async (url, data) => {
  let response = {};
  let json = {};
  let text = '';

  response = await Promise.race([
    fetch(API_URL + url, {
      method, // *GET, POST, PUT, DELETE, etc.
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getToken(),
      },
      body: JSON.stringify(data),
    }),
    new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), TIMEOUT)),
  ]);

  try {
    json = await response.clone().json();
  } catch (errorA) {
    console.error(errorA); // eslint-disable-line no-console
    try {
      text = await response.clone().text();
    } catch (errorB) {
      console.error(errorB); // eslint-disable-line no-console
    }
  }

  if (!response.ok) {
    throw new HttpError(
      response.status,
      response.statusText,
      {
        ...json,
        errorMessage: text,
      },
    );
  }

  return json;
};

const post = postData('POST');
const put = postData('PUT');
const deleteMethod = postData('DELETE');

const get = async (url) => {
  let response = {};
  let json = {};
  let text = '';

  response = await Promise.race([
    fetch(API_URL + url, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        Authorization: getToken(),
      },
    }),
    new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), TIMEOUT)),
  ]);

  try {
    json = await response.clone().json();
  } catch (errorA) {
    console.error(errorA); // eslint-disable-line no-console
    try {
      text = await response.clone().text();
    } catch (errorB) {
      console.error(errorB); // eslint-disable-line no-console
    }
  }

  if (!response.ok) {
    throw new HttpError(
      response.status,
      response.statusText,
      {
        ...json,
        errorMessage: text,
      },
    );
  }

  return json;
};

export default {
  post, get, put, delete: deleteMethod,
};
